import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";

import {ProviderComponent} from "./list.component";
import {ProviderApprovalComponent} from "./provider-approval.component";
import {ProviderPreferencesComponent} from "./provider-preferences.component";
import {ProviderRegistrationComponent} from "./provider-registration.component";

// Chart.js Angular 2 Directive by Valor Software (npm)
import { ChartsModule } from 'ng2-charts/ng2-charts';

import { FlotModule } from '../../components/charts/flotChart';
import { IboxtoolsModule } from '../../components/common/iboxtools/iboxtools.module';
import { PeityModule } from '../../components/charts/peity';
import { SparklineModule } from '../../components/charts/sparkline';
import { JVectorMapModule } from '../../components/map/jvectorMap';


@NgModule({
  declarations: [ProviderComponent,ProviderApprovalComponent,ProviderPreferencesComponent,ProviderRegistrationComponent],
  imports     : [ChartsModule, FlotModule,IboxtoolsModule,PeityModule,SparklineModule,JVectorMapModule],
  exports     : [ProviderComponent,ProviderApprovalComponent,ProviderPreferencesComponent,ProviderRegistrationComponent],
})

export class ProviderModule {}



// WEBPACK FOOTER //
// ./src/app/views/provider/provider.module.ts